import axios from 'axios';
import url from '../url.js';

const API_BASE = `${url.backendHost}api/partners`;

const partnerService = {
  // Get all partners for current user
  getAllPartners: async (page = 1, limit = 10) => {
    const response = await axios.get(API_BASE, {
      params: { page, limit },
      withCredentials: true
    });
    return response.data;
  },

  // Get a specific partner by ID
  getPartner: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create a new partner
  createPartner: async (partnerData) => {
    const response = await axios.post(API_BASE, partnerData, {
      withCredentials: true
    });
    return response.data;
  },

  // Update an existing partner
  updatePartner: async (id, partnerData) => {
    const response = await axios.put(`${API_BASE}/${id}`, partnerData, {
      withCredentials: true
    });
    return response.data;
  },

  // Delete a partner
  deletePartner: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create share link for a partner
  createShareLink: async (id, shareOptions = {}) => {
    const response = await axios.post(`${API_BASE}/${id}/share`, shareOptions, {
      withCredentials: true
    });
    return response.data;
  },

  // Revoke a share link
  revokeShareLink: async (code) => {
    const response = await axios.delete(`${API_BASE}/share/${code}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Get partner template by share code
  getByShareCode: async (code) => {
    const response = await axios.get(`${API_BASE}/share/${code}`);
    return response.data;
  },

  // Clone partner from share link
  cloneFromShare: async (code, options = {}) => {
    const response = await axios.post(`${API_BASE}/share/${code}/clone`, options, {
      withCredentials: true
    });
    return response.data;
  },

  // Helper function to safely parse JSON fields
  preparePartnerData: (formData) => {
    const parseJSON = (field) => {
      if (!field || field.trim() === '') return null;
      try {
        return JSON.parse(field);
      } catch (e) {
        throw new Error(`Invalid JSON in ${field}`);
      }
    };

    return {
      name: formData.name,
      description: formData.description,
      category: formData.category,
      tags: formData.tags,
      roleTask: parseJSON(formData.roleTask),
      knowledgeBase: parseJSON(formData.knowledgeBase),
      communicationStyle: parseJSON(formData.communicationStyle),
      responseTimeline: parseJSON(formData.responseTimeline),
      isPublicTemplate: formData.isPublicTemplate
    };
  },

  // Helper function to format partner data for editing
  formatPartnerForEdit: (partner) => {
    const formatJSON = (obj) => obj ? JSON.stringify(obj, null, 2) : '';
    
    return {
      name: partner.name || '',
      description: partner.description || '',
      category: partner.category || 'general',
      tags: partner.tags || '',
      roleTask: formatJSON(partner.roleTask),
      knowledgeBase: formatJSON(partner.knowledgeBase),
      communicationStyle: formatJSON(partner.communicationStyle),
      responseTimeline: formatJSON(partner.responseTimeline),
      isPublicTemplate: partner.isPublicTemplate || false
    };
  }
};

export default partnerService; 